module.exports = __webpack_public_path__ + "img/17.9b9e3e6e.jpg";